<template>
  <div class="card">
    <div class="card-body p-0">
      <div
        v-if="this.errosValidacaoGeral.length"
        class="notice d-flex bg-light-danger rounded border-danger border border-dashed mx-9 mt-9 p-6"
      >
        <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
          <inline-svg src="media/icons/duotune/general/gen044.svg" />
        </span>
        <div class="d-flex flex-stack flex-grow-1">
          <div class="fw-bold">
            <h4 class="text-gray-800 fw-bolder">Aviso</h4>
            <div class="fs-6 text-gray-600">
              <ul>
                <li v-for="value in this.errosValidacaoGeral" :key="value">
                  {{ value }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="card-header border-0 pt-5">
        <div class="card-title">
          <div class="d-flex align-items-center position-relative my-1">
            <span class="svg-icon svg-icon-1 position-absolute ms-6">
              <inline-svg src="media/icons/duotune/general/gen004.svg" />
            </span>
            <input
              id="txtPesquisarFaturamentos"
              type="text"
              v-model="tableData.search"
              @input="onSearch($event.target.value)"
              class="form-control form-control-solid ps-15"
              placeholder="Pesquisar Faturamentos"
            />
          </div>
        </div>
        <div class="card-toolbar flex-row-fluid justify-content-end gap-5">
          <button
            @click="this.realizarConsultaStatusServico()"
            type="button"
            class="btn btn-sm btn-secondary"
            v-if="this.consultarStatusServico"
          >
            <span class="svg-icon svg-icon-2">
              <inline-svg src="media/icons/duotune/abstract/abs037.svg" />
            </span>
            Disponibilidade Serviço
          </button>
          <router-link
            v-if="this.inutilizar"
            to="/movimentacao/gerenciarNFe/inutilizacaonfe"
            class="btn btn-sm btn-secondary"
            ><span class="svg-icon svg-icon-2">
              <inline-svg src="media/icons/duotune/art/art008.svg" />
            </span>
            Inutilização</router-link
          >
          <router-link
            v-if="this.cartaCorrecao"
            to="/movimentacao/gerenciarNFe/cartacorrecaonfe"
            class="btn btn-sm btn-secondary"
            ><span class="svg-icon svg-icon-2">
              <inline-svg src="media/icons/duotune/art/art004.svg" />
            </span>
            Carta de Correção</router-link
          >
        </div>
      </div>
      <div class="card-body pt-0">
        <Datatable
          ref="tabelaNotasGerenciadorNFe"
          :table-header="tableHeader"
          :table-data="tableData"
          :table-pagination="tablePagination"
          :page-sizes="pageSizes"
          :enable-items-per-page-dropdown="true"
          :hide-on-single-page="false"
          empty-table-text="Nenhum faturamento encontrado"
          :colors="true"
          sortLabel="id"
          order="desc"
        >
          <template
            v-slot:cell-FaturamentoClienteClienteFoto="{ row: faturamento }"
          >
            <div
              v-if="
                faturamento.FaturamentoCliente &&
                faturamento.FaturamentoCliente.Cliente &&
                faturamento.FaturamentoCliente.Cliente.foto
                  ? faturamento.FaturamentoCliente.Cliente.foto
                  : ''
              "
              class="symbol symbol-50px"
            >
              <div
                class="symbol-label fs-2 fw-bold bg-light-dark"
                :style="{
                  'background-image': `url(${
                    this.$utils.getUrl() +
                    faturamento.FaturamentoCliente.Cliente.foto
                  })`,
                }"
              ></div>
            </div>
            <div v-else class="symbol symbol-50px">
              <div :class="['symbol-label fs-2 fw-bold ' + faturamento.color]">
                {{
                  faturamento.FaturamentoCliente &&
                  faturamento.FaturamentoCliente.nome
                    ? faturamento.FaturamentoCliente.nome
                        .substring(0, 1)
                        .toUpperCase()
                    : ""
                }}
              </div>
            </div>
          </template>
          <template v-slot:cell-id="{ row: faturamento }">
            <div class="text-dark fw-bolder">
              {{ faturamento.id }}
            </div>
          </template>
          <template v-slot:cell-FaturamentoClienteNome="{ row: faturamento }">
            <div class="min-w-200px align-middle">
              <div>
                <span class="text-dark text-hover-primary mb-1">
                  {{
                    faturamento.FaturamentoCliente &&
                    faturamento.FaturamentoCliente.nome
                      ? faturamento.FaturamentoCliente.nome
                      : ""
                  }}
                </span>
                <span class="text-muted fw-bold d-block">
                  {{
                    faturamento.FaturamentoCliente &&
                    faturamento.FaturamentoCliente.cpf_cnpj
                      ? faturamento.FaturamentoCliente.cpf_cnpj.length === 11
                        ? this.$utils.setMask(
                            faturamento.FaturamentoCliente.cpf_cnpj,
                            "###.###.###-##",
                            true
                          )
                        : this.$utils.setMask(
                            faturamento.FaturamentoCliente.cpf_cnpj,
                            "##.###.###/####-##",
                            true
                          )
                      : ""
                  }}
                </span>
              </div>
            </div>
          </template>
          <template v-slot:cell-status="{ row: faturamento }">
            <span
              :class="[
                faturamento.status_nfe
                  ? this.getStatusColor(faturamento.status_nfe)
                  : '',
              ]"
              >{{ faturamento.status_nfe }}</span
            >
          </template>
          <template v-slot:cell-data_emissao="{ row: faturamento }">
            <div class="min-w-100px">
              {{ this.$utils.formatarData(faturamento.data_emissao) }}
            </div>
          </template>
          <template v-slot:cell-nota="{ row: faturamento }">
            <span>{{ faturamento.nota }}</span>
          </template>
          <template v-slot:cell-modelo="{ row: faturamento }">
            <span>{{ faturamento.modelo }}</span>
          </template>
          <template v-slot:cell-serie="{ row: faturamento }">
            <span>{{ faturamento.serie }}</span>
          </template>
          <template v-slot:cell-chave_acesso="{ row: faturamento }">
            <span>{{
              faturamento.FaturamentoChaveNFe &&
              faturamento.FaturamentoChaveNFe.chave_acesso
                ? faturamento.FaturamentoChaveNFe.chave_acesso
                : ""
            }}</span>
          </template>
          <template v-slot:cell-acoes="{ row: faturamento }">
            <div class="d-flex flex-row justify-content-end gap-5">
              <button
                class="btn btn-sm btn-light btn-active-light-primary d-flex align-items-center"
                data-kt-menu-trigger="click"
                data-kt-menu-placement="bottom-end"
                data-kt-menu-flip="top-end"
                tabindex="-1"
              >
                Ações
                <span class="svg-icon svg-icon-5 ms-2 m-0">
                  <inline-svg src="media/icons/duotune/arrows/arr072.svg" />
                </span>
              </button>
              <div
                class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-250px py-4"
                data-kt-menu="true"
              >
                <div v-if="this.transmitir === true" class="menu-item px-3">
                  <a @click="transmitirNota(faturamento)" class="menu-link px-3"
                    ><span class="svg-icon svg-icon-2 m-0 me-2">
                      <inline-svg
                        src="media/icons/duotune/general/gen016.svg"
                      />
                    </span>
                    Transmitir</a
                  >
                </div>
                <div v-if="this.imprimir === true" class="menu-item px-3">
                  <a @click="imprimirNFe(faturamento)" class="menu-link px-3">
                    <span class="svg-icon svg-icon-1 m-0 me-2">
                      <i class="fas fa-print me-1 ms-1 fs-4 p-0"></i>
                    </span>
                    Imprimir Nota</a
                  >
                </div>
                <div
                  v-if="this.editarFaturamento === true"
                  class="menu-item px-3"
                >
                  <a @click="editarRegistro(faturamento)" class="menu-link px-3"
                    ><span class="svg-icon svg-icon-1 m-0 me-2">
                      <inline-svg src="media/icons/duotune/art/art005.svg" />
                    </span>
                    Editar</a
                  >
                </div>
                <div v-if="this.cancelar === true" class="menu-item px-3">
                  <a @click="cancelarNota(faturamento)" class="menu-link px-3"
                    ><span class="svg-icon svg-icon-1 m-0 me-2">
                      <inline-svg
                        src="media/icons/duotune/general/gen040.svg"
                      />
                    </span>
                    Cancelar</a
                  >
                </div>
                <div v-if="this.consultarNota === true" class="menu-item px-3">
                  <a
                    @click="consultarStatusNota(faturamento)"
                    class="menu-link px-3"
                    ><span class="svg-icon svg-icon-1 m-0 me-2">
                      <inline-svg
                        src="media/icons/duotune/general/gen004.svg"
                      />
                    </span>
                    Consultar</a
                  >
                </div>
                <div
                  v-if="this.incluirCartaCorrecaoNFe === true"
                  class="menu-item px-3"
                >
                  <a
                    @click="adicionarCartaCorrecaoNFe(faturamento)"
                    class="menu-link px-3"
                    ><span class="svg-icon svg-icon-1 m-0 me-2">
                      <inline-svg src="media/icons/duotune/art/art004.svg" />
                    </span>
                    Gerar Carta de Correção</a
                  >
                </div>
                <div
                  v-if="this.incluirInutilizacaoNFe === true"
                  class="menu-item px-3"
                >
                  <a
                    @click="adicionarInutilizacaoNFe(faturamento)"
                    class="menu-link px-3"
                    ><span class="svg-icon svg-icon-1 m-0 me-2">
                      <inline-svg src="media/icons/duotune/art/art008.svg" />
                    </span>
                    Inutilizar</a
                  >
                </div>
                <div v-if="this.transmitir === true" class="menu-item px-3">
                  <a
                    @click="corrigirDuplicidade(faturamento)"
                    class="menu-link px-3"
                    ><span class="svg-icon svg-icon-1 m-0 me-2">
                      <inline-svg
                        src="media/icons/duotune/medicine/med001.svg"
                      />
                    </span>
                    Corrigir Duplicidade</a
                  >
                </div>
                <div
                  v-if="
                    faturamento.status_nfe === 'Autorizada' ||
                    faturamento.status_nfe === 'Cancelada'
                  "
                  class="menu-item px-3"
                >
                  <a
                    @click="downloadXMLNFe(faturamento)"
                    class="menu-link px-3"
                  >
                    <span class="svg-icon svg-icon-1 m-0 me-2">
                      <i class="fas fa-file-download me-1 ms-1 fs-4 p-0"></i>
                    </span>
                    Download XML</a
                  >
                </div>
              </div>
            </div>
          </template>
          <template v-slot:cell-total="{ row: faturamento }">
            <div class="text-dark fw-bolder align-middle min-w-100px">
              R$ {{ this.$utils.formatarNumero(faturamento.total) }}
            </div>
          </template>
          <template v-slot:cell-data_autorizacao="{ row: faturamento }">
            <div class="min-w-100px">
              {{
                faturamento &&
                faturamento.FaturamentoChaveNFe &&
                faturamento.FaturamentoChaveNFe.data_autorizacao
                  ? this.$utils.formatarData(
                      faturamento.FaturamentoChaveNFe.data_autorizacao
                    )
                  : ""
              }}
            </div>
          </template>
          <template v-slot:cell-protocolo="{ row: faturamento }">
            <span>
              {{
                faturamento &&
                faturamento.FaturamentoChaveNFe &&
                faturamento.FaturamentoChaveNFe.protocolo
                  ? faturamento.FaturamentoChaveNFe.protocolo
                  : ""
              }}
            </span>
          </template>
          <template v-slot:cell-cancelamento_data="{ row: faturamento }">
            <div class="min-w-100px">
              {{
                faturamento &&
                faturamento.FaturamentoChaveNFe &&
                faturamento.FaturamentoChaveNFe.cancelamento_data
                  ? this.$utils.formatarData(
                      faturamento.FaturamentoChaveNFe.cancelamento_data
                    )
                  : ""
              }}
            </div>
          </template>
          <template v-slot:cell-cancelamento_protocolo="{ row: faturamento }">
            <span>{{
              faturamento &&
              faturamento.FaturamentoChaveNFe &&
              faturamento.FaturamentoChaveNFe.cancelamento_protocolo
                ? faturamento.FaturamentoChaveNFe.cancelamento_protocolo
                : ""
            }}</span>
          </template>
        </Datatable>
      </div>
    </div>
  </div>
  <LoadingModal
    :nomeRef="'loadingModalGerenciarNFe'"
    :mensagem="this.mensagemLoading"
    v-if="this.loading === true"
  ></LoadingModal>
  <ErroNFeModal
    v-if="exibirModalErroNFe"
    :erroOriginal="this.erroOriginal"
    :erroFormatado="this.erroFormatado"
    @exibirModalErroNFe="modalErroNFe"
  ></ErroNFeModal>
  <EditarCartaCorrecaoNFeModal
    v-if="exibirModalCartaCorrecaoNFe"
    :refCartaCorrecaoNFeEdicao="this.refCartaCorrecaoNFeEdicao"
    :id="this.idCartaCorrecaoNFe"
    @exibirEditarCartaCorrecaoNFeModal="exibirEditarCartaCorrecaoNFeModal"
    @confirmarEditarCartaCorrecaoNFeModal="confirmarEditarCartaCorrecaoNFeModal"
  >
  </EditarCartaCorrecaoNFeModal>
  <EditarInutilizacaoNFeModal
    v-if="exibirModalInutilizacaoNFe"
    :refInutilizacaoNFeEdicao="this.refInutilizacaoNFeEdicao"
    :id="this.idInutilizacaoNFe"
    @exibirEditarInutilizacaoNFeModal="exibirEditarInutilizacaoNFeModal"
    @confirmarEditarInutilizacaoNFeModal="confirmarEditarInutilizacaoNFeModal"
  >
  </EditarInutilizacaoNFeModal>
  <ViewFilePDF
    v-if="exibirImpressaoPDF"
    :show="exibirImpressaoPDF"
    :documento="documentoImpressao"
    :dadosEmail="dadosEmail"
    @exibirModalImpressao="exibirModalImpressao"
  ></ViewFilePDF>
</template>

<script>
import { getOrCreateInstanceModal, hideModalId } from "@/core/helpers/dom";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import Datatable from "@/components/kt-datatable/KTDatatableCustom.vue";
import LoadingModal from "@/components/modals/general/LoadingModal.vue";
import { mapState } from "vuex";
import { useToast } from "vue-toastification";
import ErroNFeModal from "@/views/gerenciarnfe/ErroNFeModal.vue";
import EditarCartaCorrecaoNFeModal from "@/views/gerenciarnfe/EditarCartaCorrecaoNFeModal.vue";
import EditarInutilizacaoNFeModal from "@/views/gerenciarnfe/EditarInutilizacaoNFeModal.vue";
import ViewFilePDF from "@/components/modals/general/ViewFilePDF";

const toast = useToast();
export default {
  components: {
    Datatable,
    LoadingModal,
    ErroNFeModal,
    EditarCartaCorrecaoNFeModal,
    EditarInutilizacaoNFeModal,
    ViewFilePDF,
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
    async verificarRestricoes() {
      if (this.user.User.EmitenteTipoUsuario.EmitenteRestricao != null) {
        this.user.User.EmitenteTipoUsuario.EmitenteRestricao.find((element) => {
          if (
            element.regra === "Permitir.GerenciadorNFe.ConsultarStatusServico"
          ) {
            this.consultarStatusServico = true;
          }
          if (element.regra === "Permitir.GerenciadorNFe.ConsultarNota") {
            this.consultarNota = true;
          }
          if (element.regra === "Permitir.GerenciadorNFe.Transmitir") {
            this.transmitir = true;
          }
          if (element.regra === "Permitir.GerenciadorNFe.Imprimir") {
            this.imprimir = true;
          }
          if (element.regra === "Permitir.GerenciadorNFe.Cancelar") {
            this.cancelar = true;
          }
          if (element.regra === "Permitir.GerenciadorNFe.Inutilizar") {
            this.inutilizar = true;
          }
          if (element.regra === "Permitir.GerenciadorNFe.CartaCorrecao") {
            this.cartaCorrecao = true;
          }
          if (element.regra === "Permitir.Faturamento.Alterar") {
            this.editarFaturamento = true;
          }

          if (element.regra === "Permitir.InutilizacaoNFe.Incluir") {
            this.incluirInutilizacaoNFe = true;
          }

          if (element.regra === "Permitir.CartaCorrecaoNFe.Incluir") {
            this.incluirCartaCorrecaoNFe = true;
          }
        });
      }
    },
    getStatusColor(situacao) {
      if (situacao.toUpperCase() === "EM DIGITAÇÃO") {
        return "badge badge-light-primary";
      } else if (situacao.toUpperCase() === "CANCELADA") {
        return "badge badge-light-danger";
      } else if (situacao.toUpperCase() === "AUTORIZADA") {
        return "badge badge-success";
      } else {
        return "badge badge-light-dark";
      }
    },
    onSearch(pesquisa) {
      if (pesquisa !== "") {
        pesquisa = pesquisa.replace("'", "''");
        this.tableData.filterOData =
          "&$filter=modelo eq '55' and contains(nota, '" +
          pesquisa +
          "') or contains(status_nfe, '" +
          pesquisa +
          "') or contains(FaturamentoCliente/nome, '" +
          pesquisa +
          "') or contains(FaturamentoCliente/cpf_cnpj, '" +
          this.$utils.unMask(pesquisa) +
          "') or contains(FaturamentoChaveNFe/chave_acesso, '" +
          pesquisa +
          "') ";
        if (this.$utils.isNumber(pesquisa)) {
          this.tableData.filterOData =
            this.tableData.filterOData + " or id eq " + pesquisa;
        }
      } else {
        this.tableData.filterOData = "";
      }
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async exibirModalLoading(exibir) {
      if (exibir === true) {
        this.loading = true;
        await this.sleep(100);
        getOrCreateInstanceModal("loadingModalGerenciarNFe");
      } else {
        await this.sleep(500);
        hideModalId("loadingModalGerenciarNFe");
        await this.sleep(100);
        this.loading = false;
      }
    },
    async realizarConsultaStatusServico() {
      var alert = await Swal.fire({
        text: "Deseja consultar a disponibilidade do serviço?",
        icon: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        customClass: {
          confirmButton: "btn fw-bold btn-primary",
          cancelButton: "btn fw-bold btn-danger",
        },
      });
      if (alert.isConfirmed) {
        try {
          this.loading = true;
          await this.exibirModalLoading(true);

          let result = await this.$store.dispatch(
            "gerenciadorNFe/consultarStatusServico",
            ""
          );

          if (result.Success === true) {
            if (result.Data && result.Data.XMotivo) {
              let mensagem = result.Data.CStat + " - " + result.Data.XMotivo;
              await this.showSuccessAlert(mensagem);
            }
          } else {
            await this.showInvalidAlert(result.Message);
          }
        } catch (error) {
          if (error.Message) {
            await this.showInvalidAlert(error.Message);
          } else {
            await this.showInvalidAlert(error);
            console.log(error);
          }
        }
        await this.exibirModalLoading(false);
        this.loading = false;
      }
    },
    async showQuestionAlert(text) {
      return await Swal.fire({
        text: text,
        icon: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "ENTER - Sim",
        cancelButtonText: "ESC - Não",
        customClass: {
          confirmButton: "btn fw-bold btn-primary",
          cancelButton: "btn fw-bold btn-danger",
        },
        didOpen: () => {
          if (this.timeOut) {
            clearTimeout(this.timeOut);
            this.timeOut = null;
          }

          const confirmButton = document.querySelector(".swal2-confirm");
          if (confirmButton) {
            confirmButton.focus();
          }

          document.addEventListener("keydown", this.handleEnterKey);
        },
        willClose: () => {
          document.removeEventListener("keydown", this.handleEnterKey);
        },
      });
    },
    async showInvalidAlert(text) {
      await Swal.fire({
        text: text,
        icon: "warning",
        buttonsStyling: false,
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "btn fw-bold btn-warning",
        },
        didOpen: () => {
          if (this.timeOut) {
            clearTimeout(this.timeOut);
            this.timeOut = null;
          }

          const confirmButton = document.querySelector(".swal2-confirm");
          if (confirmButton) {
            confirmButton.focus();
          }

          document.addEventListener("keydown", this.handleEnterKey);
        },
        willClose: () => {
          document.removeEventListener("keydown", this.handleEnterKey);
        },
      });
    },
    async showSuccessAlert(text) {
      await Swal.fire({
        text: text,
        icon: "success",
        buttonsStyling: false,
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "btn fw-bold btn-success",
        },
        didOpen: () => {
          if (this.timeOut) {
            clearTimeout(this.timeOut);
            this.timeOut = null;
          }

          const confirmButton = document.querySelector(".swal2-confirm");
          if (confirmButton) {
            confirmButton.focus();
          }

          document.addEventListener("keydown", this.handleEnterKey);
        },
        willClose: () => {
          document.removeEventListener("keydown", this.handleEnterKey);
        },
      });
    },
    handleEnterKey(event) {
      if (event.key === "Enter") {
        const confirmButton = document.querySelector(".swal2-confirm");
        if (confirmButton) {
          confirmButton.click();
        }
      } else if (event.key === "Escape") {
        const cancelButton = document.querySelector(".swal2-cancel");
        if (cancelButton) {
          cancelButton.click();
        }
      }
    },
    async consultarStatusNota(faturamento) {
      var alert = await Swal.fire({
        text: "Deseja consultar a situação da nota?",
        icon: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        customClass: {
          confirmButton: "btn fw-bold btn-primary",
          cancelButton: "btn fw-bold btn-danger",
        },
      });
      if (alert.isConfirmed) {
        try {
          this.loading = true;
          await this.exibirModalLoading(true);

          let result = await this.$store.dispatch(
            "gerenciadorNFe/consultarStatusNota",
            faturamento.FaturamentoChaveNFe.chave_acesso
          );

          if (result.Success === true) {
            if (result.Data && result.Data.XMotivo) {
              let mensagem = result.Data.CStat + " - " + result.Data.XMotivo;
              await this.showSuccessAlert(mensagem);
            }
          } else {
            await this.showInvalidAlert(result.Message);
          }
        } catch (error) {
          if (error.Message) {
            await this.showInvalidAlert(error.Message);
          } else {
            await this.showInvalidAlert(error);
            console.log(error);
          }
        }
        await this.exibirModalLoading(false);
        this.loading = false;
      }
    },
    async transmitirNota(faturamento) {
      if (faturamento.status_nfe.toUpperCase() === "EM DIGITAÇÃO") {
        var alert = await Swal.fire({
          text: "Deseja transmitir a nota selecionada?",
          icon: "question",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
          customClass: {
            confirmButton: "btn fw-bold btn-primary",
            cancelButton: "btn fw-bold btn-danger",
          },
        });
        if (alert.isConfirmed) {
          try {
            this.erroOriginal = "";
            this.erroFormatado = "";

            this.loading = true;
            this.mensagemLoading = "Transmitindo a NF-e";
            await this.exibirModalLoading(true);

            let result = await this.$store.dispatch(
              "gerenciadorNFe/transmitirNota",
              faturamento.id
            );

            if (result.Success === true) {
              if (result.Data && result.Data.XMotivo) {
                let mensagem = result.Data.CStat + " - " + result.Data.XMotivo;

                this.$refs.tabelaNotasGerenciadorNFe.setLoading(true);
                this.$refs.tabelaNotasGerenciadorNFe.load();
                await this.showSuccessAlert(mensagem);
              }
            } else {
              if (result.Data) {
                if (
                  result.Data.ProtNFe &&
                  result.Data.ProtNFe.length > 0 &&
                  result.Data.ProtNFe[0].InfProt
                ) {
                  let mensagem =
                    result.Data.ProtNFe[0].InfProt.CStat +
                    " - " +
                    result.Data.ProtNFe[0].InfProt.XMotivo;

                  this.$refs.tabelaNotasGerenciadorNFe.setLoading(true);
                  this.$refs.tabelaNotasGerenciadorNFe.load();

                  await this.exibirMensagemErroSimplificada(mensagem);
                } else if (result.Data && result.Data.CStat) {
                  let mensagem =
                    result.Data.CStat + " - " + result.Data.XMotivo;
                  await this.exibirMensagemErroSimplificada(mensagem);
                } else {
                  await this.showInvalidAlert(result.Message);
                }
              } else {
                await this.showInvalidAlert(result.Message);
              }
            }
          } catch (error) {
            if (error.Message) {
              await this.showInvalidAlert(error.Message);
            } else {
              var mensagemFormatada = await this.$utils.formatarMensagem(error);
              if (mensagemFormatada !== "") {
                this.erroOriginal = error;
                this.erroFormatado = mensagemFormatada;
                this.exibirModalErroNFe = true;
                await this.modalErroNFe(true);
              }
            }
          }
          await this.exibirModalLoading(false);
          this.loading = false;
          this.mensagemLoading = "";
        }
      } else {
        await this.showInvalidAlert(
          "O status da nota indica que a mesma não está em digitação."
        );
      }
    },
    async cancelarNota(faturamento) {
      if (
        faturamento.status_nfe.toUpperCase() === "AUTORIZADA" ||
        faturamento.status_nfe.toUpperCase() === "IMPRESSA"
      ) {
        let alert = await Swal.fire({
          title: "Deseja cancelar a nota selecionada?",
          icon: "question",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
          customClass: {
            confirmButton: "btn fw-bold btn-primary",
            cancelButton: "btn fw-bold btn-danger",
          },
        });
        if (alert.isConfirmed) {
          try {
            let justificativaAlert = await Swal.fire({
              title: "Informe a justificativa para o cancelamento",
              html: `<input type="text" maxlength="255" class="form-control" id="justificativaCancelamento" placeholder="Mínimo 15 caracteres" />`,
              buttonsStyling: false,
              showCancelButton: true,
              confirmButtonText: "Confirmar",
              cancelButtonText: "Cancelar",
              customClass: {
                confirmButton: "btn fw-bold btn-primary",
                cancelButton: "btn fw-bold btn-danger",
              },
              inputValidator: (value) => {
                if (!value || value.length < 15) {
                  return "A justificativa deve conter pelo menos 15 caracteres.";
                }
              },
              preConfirm: () => ({
                justificativaInput: document.getElementById(
                  "justificativaCancelamento"
                ).value,
              }),
              didOpen: () => {
                const inputElement = document.getElementById(
                  "justificativaCancelamento"
                );
                if (inputElement) {
                  inputElement.focus();
                }
              },
            });
            if (justificativaAlert.isConfirmed) {
              if (
                justificativaAlert.value.justificativaInput !== null &&
                justificativaAlert.value.justificativaInput.length >= 15
              ) {
                this.erroOriginal = "";
                this.erroFormatado = "";

                this.loading = true;
                this.mensagemLoading = "Cancelando a NF-e";
                await this.exibirModalLoading(true);

                var cancelamento = {
                  id: faturamento.id,
                  justificativa: justificativaAlert.value.justificativaInput,
                };

                let result = await this.$store.dispatch(
                  "gerenciadorNFe/cancelarNota",
                  cancelamento
                );

                if (result.Success === true) {
                  if (result.Data && result.Data.XMotivo) {
                    let mensagem =
                      result.Data.CStat + " - " + result.Data.XMotivo;

                    this.$refs.tabelaNotasGerenciadorNFe.setLoading(true);
                    this.$refs.tabelaNotasGerenciadorNFe.load();
                    await this.showSuccessAlert(mensagem);
                  }
                } else {
                  if (result.Data) {
                    if (result.Data.ProtNFe && result.Data.ProtNFe[0].InfProt) {
                      let mensagem =
                        result.Data.ProtNFe[0].InfProt.CStat +
                        " - " +
                        result.Data.ProtNFe[0].InfProt.XMotivo;
                      await this.exibirMensagemErroSimplificada(mensagem);
                    } else if (result.Data && result.Data.CStat) {
                      let mensagem =
                        result.Data.CStat + " - " + result.Data.XMotivo;
                      await this.exibirMensagemErroSimplificada(mensagem);
                    } else {
                      await this.showInvalidAlert(result.Message);
                    }
                  } else {
                    await this.showInvalidAlert(result.Message);
                  }
                }
              } else {
                await this.showInvalidAlert(
                  "A justificativa deve ter no mínimo 15 caracteres."
                );
              }
            }
          } catch (error) {
            if (error.Message) {
              await this.showInvalidAlert(error.Message);
            } else {
              var mensagemFormatada = await this.$utils.formatarMensagem(error);
              if (mensagemFormatada !== "") {
                this.erroOriginal = error;
                this.erroFormatado = mensagemFormatada;
                this.exibirModalErroNFe = true;
                await this.modalErroNFe(true);
              }
            }
          }
          await this.exibirModalLoading(false);
          this.loading = false;
          this.mensagemLoading = "";
        }
      } else if (faturamento.status_nfe.toUpperCase() === "CANCELADA") {
        await this.showInvalidAlert(
          "A status indica que a nota já está cancelada!"
        );
      } else {
        await this.showInvalidAlert(
          "O status da nota indica que a mesma não está autorizada."
        );
      }
    },
    async exibirMensagemErroSimplificada(informacao) {
      this.erroOriginal = informacao;
      this.erroFormatado = [{ erroFormatado: informacao, tagErro: informacao }];
      this.exibirModalErroNFe = true;
      await this.modalErroNFe(true);
    },
    async modalErroNFe(exibir) {
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal("kt_modal_erro_nfe");
        }, 100);
      } else {
        await new Promise(() =>
          setTimeout(hideModalId("kt_modal_erro_nfe"), 100)
        );
        this.exibirModalErroNFe = false;
      }
    },
    async editarRegistro(faturamento) {
      if (faturamento.status_nfe.toUpperCase() === "EM DIGITAÇÃO") {
        this.$router.push("/movimentacao/faturamento/editar/" + faturamento.id);
      } else {
        await this.showInvalidAlert(
          "O status da nota indica que a mesma não está em digitação."
        );
      }
    },
    exibirEditarCartaCorrecaoNFeModal(exibir) {
      this.exibirModalCartaCorrecaoNFe = exibir;
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal("kt_editar_carta_correcao_nfe_modal");
        }, 100);
      }
    },
    async adicionarCartaCorrecaoNFe(faturamento) {
      if (
        faturamento.status_nfe.toUpperCase() === "AUTORIZADA" ||
        faturamento.status_nfe.toUpperCase() === "IMPRESSA"
      ) {
        this.idCartaCorrecaoNFe = -1;
        this.refCartaCorrecaoNFeEdicao = {
          chave_acesso: faturamento.FaturamentoChaveNFe.chave_acesso,
          correcao: "",
        };
        this.exibirEditarCartaCorrecaoNFeModal(true);
      } else {
        await this.showInvalidAlert(
          "O status da nota indica que a mesma não está autorizada."
        );
      }
    },
    async confirmarEditarCartaCorrecaoNFeModal() {
      this.$router.push("/movimentacao/gerenciarNFe/cartacorrecaonfe");
    },

    async confirmarEditarInutilizacaoNFeModal() {
      this.$router.push("/movimentacao/gerenciarNFe/inutilizacaonfe");
    },

    exibirEditarInutilizacaoNFeModal(exibir) {
      this.exibirModalInutilizacaoNFe = exibir;
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal("kt_editar_inutilizacao_nfe_modal");
        }, 100);
      }
    },

    async adicionarInutilizacaoNFe(faturamento) {
      if (faturamento.status_nfe.toUpperCase() === "EM DIGITAÇÃO") {
        const dataAtual = new Date();
        const anoCompleto = dataAtual.getFullYear();
        const anoAbreviado = (anoCompleto % 100).toString();

        this.idInutilizacaoNFe = -1;
        this.refInutilizacaoNFeEdicao = {
          ano: anoAbreviado,
          modelo: "55",
          serie: faturamento.serie,
          n_nf_ini: faturamento.nota,
          n_nf_fin: faturamento.nota,
          justificativa: "Quebra de sequência da NF-e",
        };
        this.exibirEditarInutilizacaoNFeModal(true);
      } else {
        await this.showInvalidAlert(
          "O status da nota indica que a mesma não está em digitação."
        );
      }
    },
    async exibirModalImpressao(exibir) {
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal("kt_modal_view_file_pdf");
        }, 100);
      } else {
        await new Promise(
          () => setTimeout(hideModalId("kt_modal_view_file_pdf"), 100),
          (this.documentoImpressao = []),
          (this.exibirImpressaoPDF = exibir)
        );
      }
    },
    async imprimirNFe(faturamento) {
      if (
        faturamento.status_nfe.toUpperCase() === "AUTORIZADA" ||
        faturamento.status_nfe.toUpperCase() === "IMPRESSA" ||
        faturamento.status_nfe.toUpperCase() === "CANCELADA"
      ) {
        try {
          this.dadosEmail = [];
          this.documentoImpressao = [];
          this.$refs.tabelaNotasGerenciadorNFe.setLoading(true);
          var response = await this.$store.dispatch(
            "gerenciadorNFe/imprimirNFe",
            faturamento.id
          );

          if (response.Success === true) {
            this.documentoImpressao = response.Data.pdfFile;
            this.exibirImpressaoPDF = true;

            let emails = [];
            if (response.Data.emails && response.Data.emails.length > 0) {
              response.Data.emails.forEach((e) => {
                if (e.email.length > 0) {
                  emails.push(e.email);
                }
              });
            }

            let blob = this.$utils.dataToBlob(response.Data.pdfFile);
            let pdf = [];
            let xml = [];

            await this.$utils.blobToBase64(blob).then((res) => {
              pdf = res;
            });

            if (response.Data.xml) {
              let blobXML = this.$utils.base64ToBlob(response.Data.xml);
              await this.$utils.blobToBase64(blobXML).then((res) => {
                xml = res;
              });
            }

            this.dadosEmail = await this.$utils.dadosEmailNFe(
              faturamento.FaturamentoChaveNFe.chave_acesso
            );
            this.dadosEmail.emails = emails;
            this.dadosEmail.anexosEmail = [
              { nome: "NFe.pdf", base64Arquivo: pdf },
              {
                nome: faturamento.FaturamentoChaveNFe.chave_acesso + ".xml",
                base64Arquivo: xml,
              },
            ];

            await this.exibirModalImpressao(true);
          } else {
            await Swal.fire({
              text: response.Message,
              icon: "warning",
              buttonsStyling: false,
              confirmButtonText: "OK",
              customClass: {
                confirmButton: "btn fw-bold btn-warning",
              },
            });
          }
        } catch (error) {
          await Swal.fire({
            text: "Não foi possível imprimir a NF-e!",
            icon: "warning",
            buttonsStyling: false,
            confirmButtonText: "OK",
            customClass: {
              confirmButton: "btn fw-bold btn-warning",
            },
          });
        }
        this.$refs.tabelaNotasGerenciadorNFe.setLoading(false);
      } else {
        await this.showInvalidAlert(
          "O status da nota indica que a mesma não está autorizada."
        );
      }
    },
    async corrigirDuplicidade(faturamento) {
      if (faturamento.status_nfe.toUpperCase() === "EM DIGITAÇÃO") {
        var alert = await Swal.fire({
          text: "Deseja realizar a correção da duplicidade da nota selecionada?",
          icon: "question",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
          customClass: {
            confirmButton: "btn fw-bold btn-primary",
            cancelButton: "btn fw-bold btn-danger",
          },
        });
        if (alert.isConfirmed) {
          try {
            this.erroOriginal = "";
            this.erroFormatado = "";

            this.loading = true;
            this.mensagemLoading = "Realizando correção da duplicidade da NF-e";
            await this.exibirModalLoading(true);

            let result = await this.$store.dispatch(
              "gerenciadorNFe/corrigirDuplicidadeNFe",
              faturamento.id
            );

            if (result.Success === true) {
              if (result.Data && result.Data.XMotivo) {
                let mensagem = result.Data.CStat + " - " + result.Data.XMotivo;

                this.$refs.tabelaNotasGerenciadorNFe.setLoading(true);
                this.$refs.tabelaNotasGerenciadorNFe.load();
                await this.showSuccessAlert(mensagem);
              }
            } else {
              if (result.Data) {
                if (result.Data.ProtNFe && result.Data.ProtNFe[0].InfProt) {
                  let mensagem =
                    result.Data.ProtNFe[0].InfProt.CStat +
                    " - " +
                    result.Data.ProtNFe[0].InfProt.XMotivo;

                  this.$refs.tabelaNotasGerenciadorNFe.setLoading(true);
                  this.$refs.tabelaNotasGerenciadorNFe.load();

                  await this.exibirMensagemErroSimplificada(mensagem);
                } else if (result.Data && result.Data.CStat) {
                  let mensagem =
                    result.Data.CStat + " - " + result.Data.XMotivo;
                  await this.exibirMensagemErroSimplificada(mensagem);
                } else {
                  await this.showInvalidAlert(result.Message);
                }
              } else {
                await this.showInvalidAlert(result.Message);
              }
            }
          } catch (error) {
            if (error.Message) {
              await this.showInvalidAlert(error.Message);
            } else {
              var mensagemFormatada = await this.$utils.formatarMensagem(error);
              if (mensagemFormatada !== "") {
                this.erroOriginal = error;
                this.erroFormatado = mensagemFormatada;
                this.exibirModalErroNFe = true;
                await this.modalErroNFe(true);
              }
            }
          }
          await this.exibirModalLoading(false);
          this.loading = false;
          this.mensagemLoading = "";
        }
      } else {
        await this.showInvalidAlert(
          "O status da nota indica que a mesma não está em digitação."
        );
      }
    },

    async downloadXMLNFe(faturamento) {
      try {
        this.loading = true;
        this.mensagemLoading =
          "Aguarde, consultando arquivo para o download...";
        await this.exibirModalLoading(true);

        let result = await this.$store.dispatch(
          "gerenciadorNFe/downloadXMLNFe",
          faturamento.id
        );

        if (result.Success === true) {
          if (result.Data && result.Data.xml) {
            result.Data.xml.forEach((e) => {
              let blobXML = this.$utils.base64ToBlob(e.xml);
              this.$utils.blobToBase64(blobXML).then((res) => {
                let xml = res;
                var fileURL = [];
                var base64 = this.$utils.extractBase64Data(xml);
                if (base64) {
                  let blob = this.$utils.base64ToBlob(base64);
                  fileURL = window.URL.createObjectURL(new Blob([blob]));
                  var fileLink = document.createElement("a");
                  fileLink.href = fileURL;
                  fileLink.setAttribute("download", e.nome);
                  document.body.appendChild(fileLink);
                  fileLink.click();
                }
              });
            });
          }
        } else {
          await this.showInvalidAlert(result.Message);
        }
      } catch (error) {
        if (error.Message) {
          await this.showInvalidAlert(error.Message);
        }
      }
      await this.exibirModalLoading(false);
      this.loading = false;
      this.mensagemLoading = "";
    },
  },
  async mounted() {
    await this.verificarRestricoes();
    setTimeout(() => {
      this.nextFocus("txtPesquisarFaturamentos");
    }, 800);
  },
  data() {
    return {
      incluirCartaCorrecaoNFe: false,
      incluirInutilizacaoNFe: false,
      loading: false,
      editarFaturamento: false,
      editar: false,
      consultarStatusServico: false,
      consultarNota: false,
      transmitir: false,
      imprimir: false,
      cancelar: false,
      inutilizar: false,
      cartaCorrecao: false,
      errosValidacaoGeral: [],
      exibirModalErroNFe: false,
      erroOriginal: "",
      erroFormatado: "",
      mensagemLoading: "",
      exibirModalCartaCorrecaoNFe: false,
      refCartaCorrecaoNFeEdicao: {},
      idCartaCorrecaoNFe: -1,
      exibirModalInutilizacaoNFe: false,
      refInutilizacaoNFeEdicao: {},
      idInutilizacaoNFe: -1,
      documentoImpressao: [],
      exibirImpressaoPDF: false,
      dadosEmail: [],
      tableHeader: [
        {
          key: "FaturamentoClienteClienteFoto",
          sortingField: "FaturamentoCliente/Cliente/foto",
          sortable: false,
        },
        {
          name: "ID",
          key: "id",
          sortable: true,
        },
        {
          name: "Cliente",
          key: "FaturamentoClienteNome",
          sortingField: "FaturamentoCliente/nome",
          sortable: true,
        },
        {
          name: "Status",
          key: "status",
          sortable: true,
        },
        {
          name: "Emissão",
          key: "data_emissao",
          sortable: true,
        },
        {
          name: "Nota",
          key: "nota",
          sortable: true,
        },
        {
          name: "Modelo",
          key: "modelo",
          sortable: true,
        },
        {
          name: "Série",
          key: "serie",
          sortable: true,
        },
        {
          name: "Chave de Acesso",
          key: "chave_acesso",
          sortable: true,
        },
        {
          name: "Ações",
          key: "acoes",
          sortable: false,
        },
        {
          name: "Total",
          key: "total",
          sortable: true,
        },
        {
          name: "Data Autorização",
          key: "data_autorizacao",
          sortable: true,
        },
        {
          name: "Protocolo",
          key: "protocolo",
          sortable: false,
        },
        {
          name: "Data Cancelamento",
          key: "cancelamento_data",
          sortable: true,
        },
        {
          name: "Protocolo Cancelamento",
          key: "cancelamento_protocolo",
          sortable: true,
        },
      ],
      tableData: {
        store: "faturamento/getFaturamentoOData",
        selectOData:
          "?$select=id,total,data_emissao,status_nfe,nota,modelo,serie&$expand=FaturamentoCliente($select=nome,cpf_cnpj;expand=Cliente($select=foto))&$expand=FaturamentoChaveNFe($select=chave_acesso,data_autorizacao,protocolo,cancelamento_data,cancelamento_protocolo)",
        filterOData: "&$filter=modelo eq '55'",
        search: "",
      },
      tablePagination: {
        page: 1,
        rowsPerPage: 10,
      },
      pageSizes: ["5", "10", "15", "20", "30", "50", "100"],
    };
  },
};
</script>

<style></style>
